import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import { isPositiveNumber, reduce } from "et3-type-guards";
import getKhattabat101CGeneralStore from "./101c-stores/101c-general-store";
import { TSelectionPages } from "../../Types";
import getKhattabat101MGeneralStore from "./101m-stores/general-101m-store";

class KhattabatSelectsStore {
  selectedConversations = observable.box<{
    [userID in number]: boolean;
  }>({});
  targetedUserIds = (pageType: TSelectionPages): number[] => {
    switch (pageType) {
      case "clientPage":
        return getKhattabat101CGeneralStore().getClients.get();
      case "matchResultPage":
        return getKhattabat101MGeneralStore().getMatches();
      default:
        return [];
    }
  };

  allLoadedUserIds = (pageType: TSelectionPages): number[] => {
    switch (pageType) {
      case "clientPage":
        return getKhattabat101CGeneralStore().clientsIDs.get();
      case "matchResultPage":
        return getKhattabat101MGeneralStore().loadedMatchesIDs.get();
      default:
        return [];
    }
  };
  getMarkedUserIds = () => {
    const initialIds = Object.keys(this.selectedConversations.get());
    let filteredInitialIds: number[] = [];
    initialIds.forEach((id) => {
      if (this.selectedConversations.get()[parseInt(id, 10)]) {
        filteredInitialIds.push(parseInt(id, 10));
      }
    });
    return filteredInitialIds;
  };

  toggleAllMarksStates = (pageType: TSelectionPages) => {
    if (this.isSelectedAll(pageType)) {
      this.initializeAndClearMarksStateWithClients(pageType);
    } else {
      this.selectAllClients(pageType);
    }
  };

  markUserConversation = (userID: number, state: boolean) => {
    runInAction(() => {
      this.selectedConversations.get()[userID] = state;
    });
  };

  selectAllClients = (pageType: TSelectionPages) => {
    this.initializeAndClearMarksStateWithClients(pageType);
    this.targetedUserIds(pageType).forEach((id) => {
      this.markUserConversation(id, true);
    });
  };

  initializeAndClearMarksStateWithClients = (pageType: TSelectionPages) => {
    this.resetSelectedConversations();
    runInAction(() => {
      this.allLoadedUserIds(pageType).forEach((id) => {
        this.markUserConversation(id, false);
      });
    });
  };

  isMarkedConversation = (userID: number) => {
    return reduce(() => this.selectedConversations.get()[userID], false);
  };

  selectedCount = computed(() => {
    return this.getMarkedUserIds().length;
  });

  toggleMarkConversation = ({ userID }: { userID: number }) => {
    const oldState = reduce(() => this.isMarkedConversation(userID), false);
    runInAction(() => {
      this.selectedConversations.get()[userID] = !oldState;
    });
  };

  isSelectedAll = (pageType: TSelectionPages) => {
    let currentUsersIdLength = this.targetedUserIds(pageType).length;
    return (
      currentUsersIdLength === this.selectedCount.get() &&
      isPositiveNumber(currentUsersIdLength)
    );
  };

  resetSelectedConversations = () => {
    runInAction(() => {
      this.selectedConversations.set({});
    });
  };
}

export const getKhattabatSelectsStore = memoize(
  () => {
    return new KhattabatSelectsStore();
  },
  () => 1
);

export default getKhattabatSelectsStore;
